export const API_URL = 'https://api.videmix.com/api';
export const HEALTH_API_URL = `${API_URL}/actuator/health`;
export const GOOGLE_AUTH_URL = `${API_URL}/oauth2/authorization/google`;
export const VIDEO_FILE_UPLOAD_URL = `${API_URL}/videos/link/upload`;
export const VIDEO_ID_DOWNLOAD_URL = `${API_URL}/videos/link/download/`;
export const VIDEOS_URL = `${API_URL}/videos`;
export const EDIT_VIDEO_URL = `${API_URL}/video-editing`;
